// extracted by mini-css-extract-plugin
module.exports = {"selector":"_Ki7DN","title":"kjYaCe","chart":"kE_rud"};